export default "__VITE_ASSET__BPWUmTLf__"